exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-c6520582]{margin-top:20px;padding-right:20px}.addhead ul li[data-v-c6520582]{width:100%}.addhead .video[data-v-c6520582]{width:300px;height:300px}.addhead .upload-wrapper[data-v-c6520582]{position:relative;margin-right:15px}.addhead .upload-wrapper .upload-file-cn[data-v-c6520582]{position:absolute;height:33px;opacity:0;border:none}.addhead .upload-wrapper .upload-file-en[data-v-c6520582]{position:absolute;height:33px;opacity:0;border:none}.addhead .upload-wrapper .upload-file-ja[data-v-c6520582]{position:absolute;height:33px;opacity:0;border:none}\n", ""]);

// exports
